import { render, staticRenderFns } from "./ui-scrollable-component.vue?vue&type=template&id=562df95e&scoped=true&"
import script from "./ui-scrollable-component.vue?vue&type=script&lang=ts&"
export * from "./ui-scrollable-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-scrollable-component.vue?vue&type=style&index=0&id=562df95e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562df95e",
  null
  
)

export default component.exports